/**
 * Mapa de aliases DataJud → tribunal.
 *
 * A API Pública do CNJ expõe um índice Elasticsearch por tribunal.
 * URL pattern: https://api-publica.datajud.cnj.jus.br/{alias}/_search
 *
 * Fonte: Wiki do CNJ — https://www.cnj.jus.br/sistemas/datajud/api-publica/
 */
/** Tribunais Superiores. */
export const DATAJUD_SUPERIORES = [
    { alias: 'api_publica_stf', sigla: 'STF', nome: 'Supremo Tribunal Federal', segmento: 1 },
    { alias: 'api_publica_stj', sigla: 'STJ', nome: 'Superior Tribunal de Justiça', segmento: 3 },
    { alias: 'api_publica_tst', sigla: 'TST', nome: 'Tribunal Superior do Trabalho', segmento: 5 },
    { alias: 'api_publica_tse', sigla: 'TSE', nome: 'Tribunal Superior Eleitoral', segmento: 6 },
    { alias: 'api_publica_stm', sigla: 'STM', nome: 'Superior Tribunal Militar', segmento: 7 },
];
/** Tribunais Regionais Federais. */
export const DATAJUD_TRFS = [
    {
        alias: 'api_publica_trf1',
        sigla: 'TRF1',
        nome: 'Tribunal Regional Federal da 1ª Região',
        segmento: 4,
        codigoTr: 1,
    },
    {
        alias: 'api_publica_trf2',
        sigla: 'TRF2',
        nome: 'Tribunal Regional Federal da 2ª Região',
        segmento: 4,
        codigoTr: 2,
    },
    {
        alias: 'api_publica_trf3',
        sigla: 'TRF3',
        nome: 'Tribunal Regional Federal da 3ª Região',
        segmento: 4,
        codigoTr: 3,
    },
    {
        alias: 'api_publica_trf4',
        sigla: 'TRF4',
        nome: 'Tribunal Regional Federal da 4ª Região',
        segmento: 4,
        codigoTr: 4,
    },
    {
        alias: 'api_publica_trf5',
        sigla: 'TRF5',
        nome: 'Tribunal Regional Federal da 5ª Região',
        segmento: 4,
        codigoTr: 5,
    },
    {
        alias: 'api_publica_trf6',
        sigla: 'TRF6',
        nome: 'Tribunal Regional Federal da 6ª Região',
        segmento: 4,
        codigoTr: 6,
    },
];
/** Tribunais Regionais do Trabalho (1-24). */
export const DATAJUD_TRTS = Array.from({ length: 24 }, (_, i) => ({
    alias: `api_publica_trt${String(i + 1)}`,
    sigla: `TRT${String(i + 1)}`,
    nome: `Tribunal Regional do Trabalho da ${String(i + 1)}ª Região`,
    segmento: 5,
    codigoTr: i + 1,
}));
/** Tribunais de Justiça (estaduais) — 27 unidades, alias = api_publica_tj{uf}. */
export const DATAJUD_TJS = [
    ['AC', 1],
    ['AL', 2],
    ['AM', 4],
    ['AP', 3],
    ['BA', 5],
    ['CE', 6],
    ['DF', 7],
    ['ES', 8],
    ['GO', 9],
    ['MA', 10],
    ['MG', 13],
    ['MS', 12],
    ['MT', 11],
    ['PA', 14],
    ['PB', 15],
    ['PE', 17],
    ['PI', 18],
    ['PR', 16],
    ['RJ', 19],
    ['RN', 20],
    ['RO', 22],
    ['RR', 23],
    ['RS', 21],
    ['SC', 24],
    ['SE', 25],
    ['SP', 26],
    ['TO', 27],
].map(([uf, codigoTr]) => ({
    alias: `api_publica_tj${uf.toLowerCase()}`,
    sigla: `TJ${uf}`,
    nome: `Tribunal de Justiça do Estado ${uf}`,
    segmento: 8,
    uf: uf,
    codigoTr: codigoTr,
}));
/** Tribunais Regionais Eleitorais — 27 unidades. */
export const DATAJUD_TRES = [
    'AC',
    'AL',
    'AM',
    'AP',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MG',
    'MS',
    'MT',
    'PA',
    'PB',
    'PE',
    'PI',
    'PR',
    'RJ',
    'RN',
    'RO',
    'RR',
    'RS',
    'SC',
    'SE',
    'SP',
    'TO',
].map((uf) => ({
    alias: `api_publica_tre-${uf.toLowerCase()}`,
    sigla: `TRE-${uf}`,
    nome: `Tribunal Regional Eleitoral de ${uf}`,
    segmento: 6,
    uf,
}));
/** Tribunais de Justiça Militar Estaduais (3 unidades: SP, MG, RS). */
export const DATAJUD_TJMS = [
    {
        alias: 'api_publica_tjmsp',
        sigla: 'TJM-SP',
        nome: 'Tribunal de Justiça Militar de São Paulo',
        segmento: 9,
        uf: 'SP',
    },
    {
        alias: 'api_publica_tjmmg',
        sigla: 'TJM-MG',
        nome: 'Tribunal de Justiça Militar de Minas Gerais',
        segmento: 9,
        uf: 'MG',
    },
    {
        alias: 'api_publica_tjmrs',
        sigla: 'TJM-RS',
        nome: 'Tribunal de Justiça Militar do Rio Grande do Sul',
        segmento: 9,
        uf: 'RS',
    },
];
/** Todos os tribunais agregados (96 ao total). */
export const DATAJUD_ALL_TRIBUNALS = [
    ...DATAJUD_SUPERIORES,
    ...DATAJUD_TRFS,
    ...DATAJUD_TRTS,
    ...DATAJUD_TJS,
    ...DATAJUD_TRES,
    ...DATAJUD_TJMS,
];
/**
 * Resolve alias DataJud a partir do número CNJ.
 *
 * Número CNJ: NNNNNNN-DD.AAAA.J.TR.OOOO
 *   J  = segmento (1=STF, 3=STJ, 4=Fed, 5=Trab, 6=Eleit, 7=Mil União, 8=Estadual, 9=Mil Estadual)
 *   TR = código tribunal (varia por segmento)
 *
 * @example
 *   tribunalAliasFromCnj('5001856-88.2024.8.24.0078') → 'api_publica_tjsc'
 *   tribunalAliasFromCnj('AREsp 12345/SP')           → null (sem mascara CNJ válida)
 */
export function tribunalAliasFromCnj(parsed) {
    // STF (segment 1)
    if (parsed.segment === 1)
        return 'api_publica_stf';
    // STJ (segment 3)
    if (parsed.segment === 3)
        return 'api_publica_stj';
    // Justiça Federal (segment 4) → TRF{tribunal}
    if (parsed.segment === 4 && parsed.tribunal >= 1 && parsed.tribunal <= 6) {
        return `api_publica_trf${String(parsed.tribunal)}`;
    }
    // Justiça do Trabalho (segment 5)
    if (parsed.segment === 5) {
        if (parsed.tribunal === 0)
            return 'api_publica_tst';
        if (parsed.tribunal >= 1 && parsed.tribunal <= 24)
            return `api_publica_trt${String(parsed.tribunal)}`;
    }
    // Justiça Eleitoral (segment 6)
    if (parsed.segment === 6) {
        if (parsed.tribunal === 0)
            return 'api_publica_tse';
        const tre = DATAJUD_TRES.find((t) => 
        // Apenas mapeamento por TR não está perfeito para TREs (CNJ usa codigo TJ).
        // Usar UF do tribunal correspondente do TJ.
        t.alias === `api_publica_tre-${tjUfFromCodigoTr(parsed.tribunal)?.toLowerCase() ?? ''}`);
        return tre?.alias ?? null;
    }
    // Justiça Militar União (segment 7)
    if (parsed.segment === 7)
        return 'api_publica_stm';
    // Justiça Estadual (segment 8) → TJ{uf}
    if (parsed.segment === 8) {
        const uf = tjUfFromCodigoTr(parsed.tribunal);
        if (uf)
            return `api_publica_tj${uf.toLowerCase()}`;
    }
    // Justiça Militar Estadual (segment 9)
    if (parsed.segment === 9) {
        if (parsed.tribunal === 13)
            return 'api_publica_tjmmg';
        if (parsed.tribunal === 21)
            return 'api_publica_tjmrs';
        if (parsed.tribunal === 26)
            return 'api_publica_tjmsp';
    }
    return null;
}
function tjUfFromCodigoTr(codigoTr) {
    const tj = DATAJUD_TJS.find((t) => t.codigoTr === codigoTr);
    return tj?.uf;
}
/** Lookup direto por alias. */
export function getTribunalByAlias(alias) {
    return DATAJUD_ALL_TRIBUNALS.find((t) => t.alias === alias);
}
/** Lookup por sigla (case-insensitive). */
export function getTribunalBySigla(sigla) {
    const up = sigla.toUpperCase();
    return DATAJUD_ALL_TRIBUNALS.find((t) => t.sigla === up);
}
//# sourceMappingURL=datajud-tribunals.js.map